import React from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions, useFetchData } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { FeatureFlags } from "../../constants/LocalServerConstants";
import { LmsEndpoints } from "../../constants/LmsEndpoints";

const MainTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];

  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="menu/borrower-application-entity"
    sortable={["Created On"]}
    columnLabelsDictionary={{
      legalText3DocumentReference: "Background Check and/or Consumer Credit Report Authorization"
    }}
  />;
};

const addBorrowerApplicationEntityFields = (myForm) => {
  myForm.addCenteredGroup([
    myForm.getInputField("Name"),
    myForm.getDropdownField("Borrower Application", LmsEndpoints.Metadata.GET.LIST_BORROWER_APPLICATIONS, { required: true }),
  ]);
  myForm.addCenteredGroup([
    myForm.getDropdownField("Organization", LmsEndpoints.Orgs.GET.LIST_USER_ORGANIZATIONS),
    myForm.getInputField("Role Option", { required: true }),
  ]);
  myForm.addCenteredGroup([
    myForm.getDropdownField("Organization Contact", LmsEndpoints.Orgs.GET.LIST_ORGANIZATION_CONTACTS),
    myForm.getInputField("Confirmation Status"),
  ]);
  myForm.addCenteredGroup([
    myForm.getCalendarField("Confirmation Date"),
    myForm.getCalendarField("Last Confirmation Request Date"),
  ]);
  myForm.addCenteredGroup([
    myForm.getDropdownField("Decline Borrower Application Input", LmsEndpoints.Metadata.GET.LIST_BORROWER_APPLICATION_INPUTS),
    myForm.getInputField("Other Decline Reason"),
  ]);
  myForm.addCenteredGroup([
    myForm.getCheckboxField("Is Active"),
  ]);
  myForm.addCenteredGroup([
    myForm.getTextareaField("Description")
  ]);
  return myForm;
};

const AddBorrowerApplicationEntityForm = () => {
  const myForm = addBorrowerApplicationEntityFields(new BCFormController({ isActive: true }, { submitSuffix: "menu/borrower-application-entity", blankWidth: 4 }));
  const formActions = ["save-new", "save-continue", "save-close", "edit", "close"];

  return <LmsFormGenerator myForm={myForm} actions={formActions}/>;
};

const EditBorrowerApplicationEntityForm = ({ id }) => {
  if (FeatureFlags.IS_DEBUG) {
    console.log(id);
  }

  const [{ data = {}, isLoading, error }] = useFetchData(`menu/borrower-application-entity/${id}`);
  const myForm = addBorrowerApplicationEntityFields(new BCFormController(data, { submitSuffix: "menu/borrower-application-entity", blankWidth: 4 }));
  const formActions = ["save", "save-close", "delete", "close"];

  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions}/>;
};

const LmsNewMenusBorrowerApplicationEntity = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (<React.Fragment>
    {isMainPage && <MainTable/>}
    {isAdd && <AddBorrowerApplicationEntityForm/>}
    {isEdit && <EditBorrowerApplicationEntityForm id={id}/>}
  </React.Fragment>);
};

export default LmsNewMenusBorrowerApplicationEntity;